<template>
  <AIButton
    :active="isAIButtonActive"
    :expand="isAIButtonExpanded"
    :expanded="expanded"
    :label="getLocaleText('ai_summary_button.label')"
    toolbar
    @click="clickAIButton"
  />
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { computed } from "vue";

import { track } from "shared/boot/analytics";
import { getLocaleText } from "shared/boot/i18n";
import AIButton from "shared/modules/AI/components/AIButton/AIButton.vue";
import { useAIStore } from "shared/modules/AI/stores/useAIStore";

interface AISummaryButtonProps {
  expand?: boolean;
  expanded?: boolean;
  streamId: number;
}

const props = defineProps<AISummaryButtonProps>();

const aiStore = useAIStore();
const { getAISummary, openAIModal } = aiStore;
const { aiModalOpen, aiSummaryStreamId } = storeToRefs(aiStore);

const aiSummary = computed(() => getAISummary(props.streamId));

const isCurrentAIStream = computed(
  () => aiSummaryStreamId.value === props.streamId
);

const isAIButtonActive = computed(() =>
  Boolean(isCurrentAIStream.value || aiSummary.value.result)
);

const isAIButtonExpanded = computed(
  () => props.expand || isCurrentAIStream.value
);

function clickAIButton() {
  track("Clicked AI Summary button", { streamId: props.streamId });

  if (aiSummaryStreamId.value !== props.streamId) {
    aiSummaryStreamId.value = props.streamId;
  }

  if (aiModalOpen.value || props.expanded) {
    openAIModal("AISummaryPanel");
  }
}
</script>
